"use strict";

exports.__esModule = true;
exports.parsePseudo = parsePseudo;

var _utils = require("@chakra-ui/utils");

var _pseudo = require("./pseudo.selector");

function parsePseudo(props) {
  var next = {};
  Object.keys(props).forEach(function (prop) {
    var propValue = props[prop];
    var propName = prop in _pseudo.pseudoSelectors ? _pseudo.pseudoSelectors[prop] : prop;

    if ((0, _utils.isObject)(propValue) && !(0, _utils.isFunction)(propValue)) {
      next[propName] = parsePseudo(propValue);
    } else {
      next[propName] = propValue;
    }
  });
  return next;
}
//# sourceMappingURL=pseudo.utils.js.map